export default function RoleService($http, appSettings) {
  'ngInject';
  const baseURL = `${appSettings.InReachApiEndpoint}/roles`;

  return {
    createRole: role => {
      if (!role) {
        return;
      }

      const endpoint = `${baseURL}`;
      return $http.post(endpoint, role);
    },
    updateRole: role => {
      if (!role) {
        return;
      }

      const endpoint = `${baseURL}/${role.id}`;
      return $http.put(endpoint, role);
    },

    getAllUsersOfRole: roleId => $http.get(`${baseURL}/${roleId}/users`),

    getRoles: options => {
      var uri = `${baseURL}`;
      if (options && 'assignable' in options) {
        uri += '?assignable=' + !!options.assignable;
      }
      return $http.get(uri);
    },

    getRole: id => $http.get(`${baseURL}/${id}`)
  };
}